import { CheckCircle } from 'lucide-react';

/**
 * CTASection Component - Premium Design
 * 
 * High-conversion call-to-action section with gradient background
 * and compelling messaging for demo/signup.
 */
function CTASection() {
    const checkpoints = [
        '100% Gratis en Beta',
        'Sin tarjeta de crédito',
        'Listo en 2 minutos'
    ];

    return (
        <section className="cta-section">
            <div className="cta-orb cta-orb-1"></div>
            <div className="cta-orb cta-orb-2"></div>
            <div className="cta-container">
                <div className="cta-content">
                    <span className="cta-badge">🌟 BETA ABIERTA</span>

                    <h2 className="cta-title">
                        Hecho para salones que están empezando
                    </h2>

                    <p className="cta-description">
                        ¿Tienes un salón de belleza y quieres algo fácil de usar?
                        Cresta es <strong>100% gratis durante nuestra fase Beta</strong>. Únete ahora, 
                        disfruta de todas las funciones premium y ayúdanos a construir el futuro de los salones.
                    </p>

                    <div className="cta-buttons" style={{ justifyContent: 'center' }}>
                        <div style={{
                            padding: '1rem 2rem',
                            background: 'rgba(255, 255, 255, 0.05)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '12px',
                            color: 'var(--gray-300)',
                            fontSize: '1rem',
                            fontWeight: '600'
                        }}>
                            Registro temporalmente pausado
                        </div>
                    </div>

                    {/* Trust Badges */}
                    <div style={{
                        display: 'flex',
                        gap: '2rem',
                        justifyContent: 'center',
                        marginTop: '2.5rem',
                        flexWrap: 'wrap'
                    }}>
                        {checkpoints.map((text, i) => (
                            <div key={i} style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '0.9rem'
                            }}>
                                <CheckCircle size={18} style={{ color: 'white' }} />
                                <span>{text}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CTASection;
